export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
    },
    // {
    //   name: 'Statistics',
    //   url: '/statics',
    //   icon: 'icon-speedometer',
    // },
    {
      title: true,
      name: 'Management',
      class: '',
      wrapper: {
        element: '',
        attributes: {},
      },
    },
    // {
    //   name: 'Menu Management',
    //   url: '/items',
    //   icon: 'icon-menu',
    // },
    {
      name: 'MenuManagement',
      url: '/items',
      icon: 'icon-menu',
      children: [
        // {
        //   name: 'Menu Categories',
        //   url: '/createcategory',
        //   icon: 'icon-list',
        // },
        {
          name: 'Menu Items',
          url: '/items',
          icon: 'icon-list',
        },

        {
          name: 'Add-on Items',
          url: '/modiferItems',
          icon: 'icon-list',
        },
        {
          name: 'Bulk Price Update',
          url: '/bulkPriceUpdate',
          icon: 'icon-list',
        },
      ],
    },
    {
      name: 'User Management',
      url: '/usermanagement',
      icon: 'icon-wrench',
      children: [
        {
          name: 'User Roles',
          url: '/userRole',
          icon: 'fa fa-users',
        },
        {
          name: 'Users',
          url: '/user',
          icon: 'icon-user',
        },
      ],
    },
    {
      name: 'Discounts',
      url: '/discount',
      icon: 'icon-tag ',
    },
    {
      name: 'Promotions',
      url: '/promotionlist',
      icon: 'icon-badge ',
    },
    {
      name: 'Custom Payments',
      url: '/customPayment',
      icon: 'cui-dollar',
    },

    {
      name: 'City Ledger',
      url: '/cityLedger',
      icon: 'icon-book-open',
      children: [
        {
          name: 'Company',
          url: '/listOrganizations',
          icon: 'icon-book-open',
        },
        {
          name: 'Accounts',
          url: '/listAccounts',
          icon: 'icon-book-open',
        },
        {
          name: 'Transaction Details',
          url: '/transactionDetailReport',
          icon: 'icon-book-open',
        },
      ],
    },
    {
      name: 'Settings',
      url: '/settings',
      icon: 'cui-settings',
      children: [
        {
          name: 'Tax',
          url: '/listCharges',
          icon: 'cui-calculator',
        },
        {
          name: 'Printer Setup',
          url: '/listPrinter',
          icon: 'icon-printer',
        },
        {
          name: 'System Settings',
          url: '/editSystemSettings',
          icon: 'cui-settings',
        },
        {
          name: 'Outlet Settings',
          url: '/editOutlet',
          icon: 'icon-home',
        },
        {
          name: 'Comments',
          url: '/comments',
          icon: 'icon-home',
        },
        {
          name: 'Floor',
          url: '/listFloor',
          icon: 'icon-home',
        },
      ],
    },
    {
      name: 'OLO',
      url: '/olo',
      icon: 'icon-briefcase',
      children: [
        {
          name: 'OLO Settings',
          url: '/oloSystemSettings',
          icon: 'icon-briefcase',
        },
        {
          name: 'OLO Menu Management',
          url: '/olomenulist',
          icon: 'icon-briefcase',
        },
      ],
    },
    {
      title: true,
      name: 'Inventory Management',
      class: '',
      wrapper: {
        element: '',
        attributes: {},
      },
    },

    {
      name: 'Inventory Master',
      url: '/inventorymaster',
      icon: 'icon-handbag',
      children: [
        {
          name: 'UOM',
          url: '/measuretypelist',
          icon: 'icon-handbag',
        },
        {
          name: 'Category',
          url: '/categorylist',
          icon: 'icon-handbag',
        },
        {
          name: 'Item Management',
          url: '/inventoryitemlist',
          icon: 'icon-handbag',
        },
        {
          name: 'Item Copy',
          url: '/itemCopy',
          icon: 'icon-handbag',
        },
        {
          name: 'Supplier',
          url: '/supplierlist',
          icon: 'icon-handbag',
        },
        {
          name: 'Create Recipe',
          url: '/createrecipe',
          icon: 'icon-handbag',
        },
        {
          name: 'Tax',
          url: '/taxlist',
          icon: 'icon-handbag',
        },
      ],
    },
    {
      name: 'Inventory',
      url: '/createpo',
      icon: 'icon-briefcase',
      children: [
        {
          name: 'PO',
          url: '/polist',
          icon: 'icon-briefcase',
        },
        {
          name: 'GRN',
          url: '/grnlist',
          icon: 'icon-briefcase',
        },
        {
          name: 'Issue Note',
          url: '/issuenotelist',
          icon: 'icon-briefcase',
        },
        {
          name: 'Supplier Return',
          url: '/supplierreturnlist',
          icon: 'icon-briefcase',
        },
        {
          name: 'Stock Adjustment',
          url: '/stockadjustmentlist',
          icon: 'icon-briefcase',
        },
        {
          name: 'Stock Entry',
          url: '/stockentrylist',
          icon: 'icon-briefcase',
        },
        // {
        //   name: 'Bulk Stock Entry',
        //   url: '/bulkStockEntry',
        //   icon: 'icon-briefcase',
        // },
        {
          name: 'Wastage Management',
          url: '/wastagemanagementlist',
          icon: 'icon-briefcase',
        },
        {
          name: 'Batch Processing',
          url: '/createINVrecipe',
          icon: 'icon-briefcase',
        },
        {
          name: 'SRN',
          url: '/srnlist',
          icon: 'icon-briefcase',
        },
        {
          name: 'Transfer Out',
          url: '/transferoutlist',
          icon: 'icon-briefcase',
        },
        {
          name: 'Transfer In',
          url: '/transferinlist',
          icon: 'icon-briefcase',
        },
        {
          name: 'Bulk Batch Process',
          url: '/bulkBatchProcess',
          icon: 'icon-briefcase',
        },
      ],
    },
    {
      name: 'Inventory Reports',
      url: '/stocksummaryreport',
      icon: 'icon-doc',
      children: [
        {
          name: 'Current Stock Summary',
          url: '/stocksummaryreport',
          icon: 'icon-doc',
        },
        {
          name: 'Current Stock Valuation',
          url: '/stockvaluationreport',
          icon: 'icon-doc',
        },
        {
          name: 'Cost Of Sales',
          url: '/costofsalesreport',
          icon: 'icon-doc',
        },
        {
          name: 'Stock Variance',
          url: '/stockvariancereport',
          icon: 'icon-doc',
        },
        {
          name: 'Stock Usage',
          url: '/stockusagereport',
          icon: 'icon-doc',
        },
        {
          name: 'GRN Listing',
          url: '/grnlistingreport',
          icon: 'icon-doc',
        },
        {
          name: 'Current Recipe Cost Details',
          url: '/recipeCostReport',
          icon: 'icon-doc',
        },
        {
          name: 'Current Batch Cost Details',
          url: '/batchprocessCostReport',
          icon: 'icon-doc',
        },
        {
          name: 'Current Profit Margin',
          url: '/profitMarginReport',
          icon: 'icon-doc',
        },
        {
          name: 'Issue Note Listing',
          url: '/issuenotelistingreport',
          icon: 'icon-doc',
        },
        {
          name: 'Transfer Out Listing',
          url: '/transferoutlistingreport',
          icon: 'icon-doc',
        },
        {
          name: 'Transfer In Listing',
          url: '/transferinlistingreport',
          icon: 'icon-doc',
        },
        {
          name: 'Batch Process Listing',
          url: '/batchProcessReport',
          icon: 'icon-doc',
        },
        {
          name: 'Wastage Note Listing',
          url: '/wastageNoteReport',
          icon: 'icon-doc',
        },
        {
          name: 'Stock Adjustment Listing',
          url: '/stockAdjustmentReport',
          icon: 'icon-doc',
        },
        {
          name: 'Stock Entry Listing',
          url: '/stockEntryReport',
          icon: 'icon-doc',
        },
        {
          name: 'Purchase Order Listing',
          url: '/PoReport',
          icon: 'icon-doc',
        },
        {
          name: 'Supplier Return Listing',
          url: '/SupplierReturnReport',
          icon: 'icon-doc',
        },
        {
          name: 'Item Transaction Listing',
          url: '/itemTransactionReport',
          icon: 'icon-doc',
        },
        {
          name: 'Recipe Item Listing',
          url: '/RecipeItemListingReport',
          icon: 'icon-doc',
        },
        {
          name: 'SRN Listing Report',
          url: '/SRNListingReport',
          icon: 'icon-doc',
        },
      ],
    },
    {
      title: true,
      name: 'Reports',
      class: '',
      wrapper: {
        element: '',
        attributes: {},
      },
    },
    {
      name: 'Reports',
      url: '/reports',
      icon: 'icon-note',
      children: [
        {
          name: 'Sales',
          url: '/salesReport',
          icon: 'icon-note',
        },
        {
          name: 'Product Category',
          url: '/productCategoryReport',
          icon: 'icon-note',
        },
        {
          name: 'Discount',
          url: '/discountReport',
          icon: 'icon-note',
        },
        {
          name: 'Order Cancellation',
          url: '/orderCancellationReport',
          icon: 'icon-note',
        },
        {
          name: 'Payment Cancellation',
          url: '/paymentCancellationReport',
          icon: 'icon-note',
        },
        {
          name: 'Bill Wise Report',
          url: '/billWiseReport',
          icon: 'icon-note',
        },
        {
          name: 'Customer Report',
          url: '/customerReport',
          icon: 'icon-note',
        },
        {
          name: 'Merge/Split Bills Report',
          url: '/mergedBillsReport',
          icon: 'icon-note',
        },
        {
          name: 'User Log Report',
          url: '/userLogReport',
          icon: 'icon-note',
        },
        {
          name: 'Advance Payment Report',
          url: '/advancePaymentReport',
          icon: 'icon-note',
        },
        {
          name: 'Menu Item Report',
          url: '/menuItemReport',
          icon: 'icon-note',
        },
        // {
        //   name: 'CC Tagging Report',
        //   url: '/ccTaggingReport',
        //   icon: 'icon-note',
        // },
        // {
        //   name: 'Table Revenue',
        //   url: '/tableRevenueReport',
        //   icon: 'icon-bell',
        // },
      ],
    },
    // {
    //   name: 'Archived Reports',
    //   url: '/archivedReports',
    //   icon: 'icon-bell',
    //   children: [{
    //       name: 'Archived Sales',
    //       url: '/archivedSalesReport',
    //       icon: 'icon-bell',
    //     },
    //     {
    //       name: 'Archived Product Category',
    //       url: '/archivedProductCategoryReport',
    //       icon: 'icon-bell',
    //     },
    //     // {
    //     //   name: 'Archived Order Cancellation',
    //     //   url: '/archivedOrderCancellationReport',
    //     //   icon: 'icon-bell',
    //     // },
    //     {
    //       name: 'Archived Payment Cancellation',
    //       url: '/archivedPaymentCancellationReport',
    //       icon: 'icon-bell',
    //     },
    //     // {
    //     //   name: 'Archived Discount',
    //     //   url: '/archivedDiscountReport',
    //     //   icon: 'icon-bell',
    //     // },
    //   ],
    // },
  ],
}
